import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const SHOW_DELAY_MS = 120;

export default function RouteProgress() {
	const router = useRouter();
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		let timer;

		const handleStart = (url, { shallow }) => {
			if (shallow) return;
			clearTimeout(timer);
			timer = setTimeout(() => setIsVisible(true), SHOW_DELAY_MS);
		};
		const handleDone = () => {
			clearTimeout(timer);
			setIsVisible(false);
		};

		router.events.on('routeChangeStart', handleStart);
		router.events.on('routeChangeComplete', handleDone);
		router.events.on('routeChangeError', handleDone);

		return () => {
			clearTimeout(timer);
			router.events.off('routeChangeStart', handleStart);
			router.events.off('routeChangeComplete', handleDone);
			router.events.off('routeChangeError', handleDone);
		};
	}, [router.events]);

	if (!isVisible) return null;

	return (
		<div
			role="progressbar"
			aria-label="Loading page"
			className="fixed inset-x-0 top-0 z-50 h-1 overflow-hidden bg-emerald-200"
		data-sentry-component="RouteProgress" data-sentry-source-file="RouteProgress.jsx">
			<div className="h-full w-1/3 animate-route-progress bg-emerald-500" />
		</div>
	);
}
